import React from "react";
import { Cancel as CancelOutIcon } from "@material-ui/icons";
import Image from "./Image";

export interface LinkPreviewData {
  url: string;
  title?: string;
  image?: string;
  domain?: string;
}

interface LinkPreviewCardProps {
  preview: LinkPreviewData | null;
  loading?: boolean;
  onRemove?: () => void;
  className?: string;
}

const LinkPreviewCard: React.FC<LinkPreviewCardProps> = ({
  preview,
  loading = false,
  onRemove,
  className = "",
}) => {
  if (!loading && !preview) return null;

  return (
    <div className={`link-preview-card ${loading ? "link-preview-loading" : ""} ${className}`}>
      {onRemove && (
        <span
          className="link-preview-close"
          onClick={onRemove}
          role="button"
          aria-label="Remove link preview"
        >
          <CancelOutIcon />
        </span>
      )}

      {loading ? (
        <div className="link-preview-skeleton">
          <div className="link-preview-skeleton-image" />
          <div className="link-preview-skeleton-text">
            <div className="link-preview-skeleton-line" />
            <div className="link-preview-skeleton-line short" />
          </div>
        </div>
      ) : (
        <a
          href={preview!.url}
          target="_blank"
          rel="noopener noreferrer"
          className="link-preview-content"
          onClick={(e) => e.stopPropagation()}
        >
          {preview!.image && (
            <div className="link-preview-image">
              <Image src={preview!.image} alt={preview!.title || preview!.domain || "link preview"} />
            </div>
          )}
          <div className="link-preview-info">
            {preview!.title && <p className="link-preview-title">{preview!.title}</p>}
            {preview!.domain && <p className="link-preview-domain">{preview!.domain}</p>}
          </div>
        </a>
      )}
    </div>
  );
};

export default LinkPreviewCard;
